<script>
  export let title;
</script>

<div class="my-6">
  <p class="font-pixel text-3xl">{title}</p>
  <blockquote class="mt-2 font-normal leading-relaxed leading-relaxed font-body bl-2 border-gray-300 text-base">
    <slot />
  </blockquote>
</div>
